<template>
  
  <TopNav />
  <NavMain />

  <router-view/>

  <FooterBottom />

  <ButtonWhatApp />
</template>

<script lang="ts" setup>
import TopNav from "@/components/Navigation/TopNav/TopNav.component.vue";
import NavMain from "@/components/Navigation/Nav/NavMain.component.vue";
import FooterBottom from "@/components/Navigation/Footer/FooterBottom.component.vue";
import ButtonWhatApp from "./components/ButtonWhatsApp/ButtonWhatApp.vue";
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;

}

#app {
  font-family: $fontFamily;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
  
}


</style>
